import ReactPlayer from 'react-player/wistia';
import { playerHeight } from '../../constants';

export const WistiaPlayer = ({ mediaId, width = '100%', height, aspectRatio = '16/9', wistiaPlayerOptions = {} }) => {
  const wistiaUrl = `https://wistia.com/medias/${mediaId}`;
  const wistiaMediaConfig = {
    options: {
      playerColor: 'black',
      ...wistiaPlayerOptions,
    },
  };

  return (
    <ReactPlayer
      url={wistiaUrl}
      controls
      width={width}
      height={height || playerHeight}
      config={{
        wistia: wistiaMediaConfig,
      }}
      style={{ aspectRatio, minHeight: height }}
    />
  );
};
